// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"ad39c4f7","445":"bde3e1ab","509":"7045eac2","671":"8fdd5cd4"}[chunkId] + ".chunk.js";
};